import {create} from "zustand";

export const useQuickViewStore = create((set, get) => ({
    open: false,
    loading: false,
    product: null,
    productDataCurrent: {},

    openModal: () => set({open: true}),

    closeModal: () => set({open: false, product: null}),

    setLoading: (loading) => set({loading}),

    setData: ({product, productDataCurrent}) => set({product, productDataCurrent}),

    /**
     * Переключаем нужный размер
     * @param el - выбранный елемент
     */
    switchSize: (el = {}) => set({productDataCurrent: el}),
}));
